@if (visible()) {
  <!-- Chat panel -->
  @if (chat.isOpen()) {
    <div class="assistant-panel" [class.expanded]="chat.isExpanded()" role="dialog" [attr.aria-label]="chat.title()">
      <div class="assistant-header">
        <div class="assistant-header-title">
          <i class="pi pi-sparkles"></i>
          <span>{{ chat.title() }}</span>
        </div>
        <div class="assistant-header-actions">
          @if (chat.isExpanded()) {
            <button
              type="button"
              class="assistant-icon-btn"
              title="Shrink"
              aria-label="Shrink chat window"
              (click)="onToggleExpanded()"
            >
              <i class="pi pi-window-minimize"></i>
            </button>
          } @else {
            <button
              type="button"
              class="assistant-icon-btn"
              title="Enlarge"
              aria-label="Enlarge chat window"
              (click)="onToggleExpanded()"
            >
              <i class="pi pi-window-maximize"></i>
            </button>
          }
          <button
            type="button"
            class="assistant-icon-btn"
            title="New conversation"
            aria-label="New conversation"
            (click)="onNewConversation()"
          >
            <i class="pi pi-refresh"></i>
          </button>
          <button type="button" class="assistant-icon-btn" title="Close" aria-label="Close" (click)="chat.close()">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>

      <div class="assistant-messages" #messageList>
        @if (chat.messages().length === 0) {
          <div class="assistant-empty">
            <i class="pi pi-sparkles"></i>
            <p class="assistant-empty-title">How can I help?</p>
            <p class="assistant-empty-hint">
              Ask, inspect, and manage your {{ chat.subject() }} in plain English — with live usage charts and metrics.
            </p>
          </div>
        }
        @for (message of chat.messages(); track $index; let last = $last) {
          @if (message.role === 'user') {
            <div class="assistant-message user">{{ message.text }}</div>
          } @else {
            <div class="assistant-message bot">
              @for (segment of segments(message, last); track $index) {
                @if (segment.kind === 'chart') {
                  <app-assistant-chart class="assistant-chart-slot" [spec]="segment.chart" />
                } @else if (segment.kind === 'table') {
                  <app-assistant-table [table]="segment.table" [scope]="chat.scope()?.kind" />
                } @else {
                  <div class="assistant-message-body" [innerHTML]="segment.html"></div>
                }
              }
              @if (answerable(message, last)) {
                <app-assistant-question [question]="message.question!" (answered)="onAnswered($event)" />
              }
              @if (message.pending) {
                <span class="assistant-typing" aria-label="Assistant is typing">
                  <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                </span>
              }
              @if (message.error) {
                <div class="assistant-message-error">
                  <i class="pi pi-exclamation-circle"></i>
                  Something went wrong. Please try again.
                </div>
              }
            </div>
          }
        }
      </div>

      <div class="assistant-input-row">
        <textarea
          #chatInput
          class="assistant-input"
          rows="1"
          placeholder="Ask the assistant…"
          [(ngModel)]="draft"
          (ngModelChange)="onDraftChanged()"
          (keydown)="onInputKeydown($event)"
        ></textarea>
        @if (chat.isStreaming()) {
          <button
            type="button"
            class="assistant-send-btn"
            title="Stop"
            aria-label="Stop response"
            (click)="chat.stop()"
          >
            <i class="pi pi-stop"></i>
          </button>
        } @else {
          <button
            type="button"
            class="assistant-send-btn"
            title="Send"
            aria-label="Send message"
            [disabled]="!draft.trim()"
            (click)="onSend()"
          >
            <i class="pi pi-send"></i>
          </button>
        }
      </div>
    </div>
  }

  <!-- Launcher bubble -->
  <button
    type="button"
    class="assistant-launcher"
    [attr.aria-expanded]="chat.isOpen()"
    [attr.aria-label]="chat.title()"
    [title]="chat.title()"
    (click)="onToggle()"
  >
    @if (chat.isOpen()) {
      <i class="pi pi-chevron-down"></i>
    } @else {
      <i class="pi pi-sparkles"></i>
    }
  </button>
}
